// Enum for all available flag file names
export enum FlagFileNames {
  AfghanFlag = "AfghanFlag",
  AmericanFlag = "AmericanFlag",
  AngolaFlag = "AngolaFlag",
  ArgentineFlag = "ArgentineFlag",
  ArmenianFlag = "ArmenianFlag",
  AustralianFlag = "AustralianFlag",
  AzerbaijaniFlag = "AzerbaijaniFlag",
  BelarusianFlag = "BelarusianFlag",
  BengaliFlag = "BengaliFlag",
  BosnianFlag = "BosnianFlag",
  BrazilianFlag = "BrazilianFlag",
  BulgarianFlag = "BulgarianFlag",
  CambodianFlag = "CambodianFlag",
  CanadianFlag = "CanadianFlag",
  CapeVerdeFlag = "CapeVerdeFlag",
  ChineseFlag = "ChineseFlag",
  CroatianFlag = "CroatianFlag",
  CzechFlag = "CzechFlag",
  DRCongoFlag = "DRCongoFlag",
  DanishFlag = "DanishFlag",
  DutchFlag = "DutchFlag",
  EstonianFlag = "EstonianFlag",
  EthiopianFlag = "EthiopianFlag",
  FilipinoFlag = "FilipinoFlag",
  FinnishFlag = "FinnishFlag",
  FrenchFlag = "FrenchFlag",
  GalicianFlag = "GalicianFlag",
  GeorgianFlag = "GeorgianFlag",
  GermanFlag = "GermanFlag",
  GreekFlag = "GreekFlag",
  HausaFlag = "HausaFlag",
  HongKongFlag = "HongKongFlag",
  HungarianFlag = "HungarianFlag",
  IcelandicFlag = "IcelandicFlag",
  IndianFlag = "IndianFlag",
  IndonesianFlag = "IndonesianFlag",
  IrishFlag = "IrishFlag",
  IsraeliFlag = "IsraeliFlag",
  ItalianFlag = "ItalianFlag",
  JapaneseFlag = "JapaneseFlag",
  KannadaFlag = "KannadaFlag",
  KazakhFlag = "KazakhFlag",
  KenyaFlag = "KenyaFlag",
  KirghizFlag = "KirghizFlag",
  KoreanFlag = "KoreanFlag",
  KurdistanFlag = "KurdistanFlag",
  LaosFlag = "LaosFlag",
  LatvianFlag = "LatvianFlag",
  LithuanianFlag = "LithuanianFlag",
  LuxembourgishFlag = "LuxembourgishFlag",
  MacedonianFlag = "MacedonianFlag",
  MalawiFlag = "MalawiFlag",
  MalayFlag = "MalayFlag",
  MalayaliFlag = "MalayaliFlag",
  MalteseFlag = "MalteseFlag",
  MaoriFlag = "MaoriFlag",
  MexicanFlag = "MexicanFlag",
  MongolianFlag = "MongolianFlag",
  MyanmarFlag = "MyanmarFlag",
  NepaliFlag = "NepaliFlag",
  NigerianFlag = "NigerianFlag",
  NorwegianFlag = "NorwegianFlag",
  PakistaniFlag = "PakistaniFlag",
  PersianFlag = "PersianFlag",
  PolishFlag = "PolishFlag",
  PortugueseFlag = "PortugueseFlag",
  RomanianFlag = "RomanianFlag",
  RussianFlag = "RussianFlag",
  ScottishFlag = "ScottishFlag",
  SenegalFlag = "SenegalFlag",
  SerbianFlag = "SerbianFlag",
  SlovakFlag = "SlovakFlag",
  SlovenianFlag = "SlovenianFlag",
  SomaliFlag = "SomaliFlag",
  SouthAfricanFlag = "SouthAfricanFlag",
  SpanishFlag = "SpanishFlag",
  SwedishFlag = "SwedishFlag",
  TajikFlag = "TajikFlag",
  ThaiFlag = "ThaiFlag",
  TurkishFlag = "TurkishFlag",
  UAEFlag = "UAEFlag",
  UKFlag = "UKFlag",
  UgandanFlag = "UgandanFlag",
  UkrainianFlag = "UkrainianFlag",
  UzbekFlag = "UzbekFlag",
  VietnameseFlag = "VietnameseFlag",
  WelshFlag = "WelshFlag",
}

// Mapping of locales to flag names
export const languageToFlagName: Record<string, FlagFileNames> = {
  af: FlagFileNames.SouthAfricanFlag,
  am: FlagFileNames.EthiopianFlag,
  ar: FlagFileNames.UAEFlag,
  as: FlagFileNames.IndianFlag,
  ast: FlagFileNames.SpanishFlag,
  az: FlagFileNames.AzerbaijaniFlag,
  be: FlagFileNames.BelarusianFlag,
  bg: FlagFileNames.BulgarianFlag,
  bn: FlagFileNames.BengaliFlag,
  br: FlagFileNames.BrazilianFlag,
  bs: FlagFileNames.BosnianFlag,
  ca: FlagFileNames.SpanishFlag,
  ceb: FlagFileNames.FilipinoFlag,
  ckb: FlagFileNames.KurdistanFlag,
  cmn: FlagFileNames.ChineseFlag,
  cs: FlagFileNames.CzechFlag,
  cy: FlagFileNames.WelshFlag,
  da: FlagFileNames.DanishFlag,
  de: FlagFileNames.GermanFlag,
  el: FlagFileNames.GreekFlag,
  en: FlagFileNames.AmericanFlag,
  es: FlagFileNames.SpanishFlag,
  et: FlagFileNames.EstonianFlag,
  fa: FlagFileNames.PersianFlag,
  ff: FlagFileNames.SenegalFlag,
  fi: FlagFileNames.FinnishFlag,
  fr: FlagFileNames.FrenchFlag,
  ga: FlagFileNames.IrishFlag,
  gl: FlagFileNames.GalicianFlag,
  gu: FlagFileNames.IndianFlag,
  ha: FlagFileNames.HausaFlag,
  he: FlagFileNames.IsraeliFlag,
  hi: FlagFileNames.IndianFlag,
  hr: FlagFileNames.CroatianFlag,
  hu: FlagFileNames.HungarianFlag,
  hy: FlagFileNames.ArmenianFlag,
  id: FlagFileNames.IndonesianFlag,
  ig: FlagFileNames.NigerianFlag,
  is: FlagFileNames.IcelandicFlag,
  it: FlagFileNames.ItalianFlag,
  ja: FlagFileNames.JapaneseFlag,
  jv: FlagFileNames.IndonesianFlag,
  ka: FlagFileNames.GeorgianFlag,
  kea: FlagFileNames.CapeVerdeFlag,
  kk: FlagFileNames.KazakhFlag,
  km: FlagFileNames.CambodianFlag,
  kn: FlagFileNames.IndianFlag,
  ko: FlagFileNames.KoreanFlag,
  ky: FlagFileNames.KirghizFlag,
  lb: FlagFileNames.LuxembourgishFlag,
  lg: FlagFileNames.UgandanFlag,
  ln: FlagFileNames.DRCongoFlag,
  lo: FlagFileNames.LaosFlag,
  luo: FlagFileNames.KenyaFlag,
  lt: FlagFileNames.LithuanianFlag,
  lv: FlagFileNames.LatvianFlag,
  mi: FlagFileNames.MaoriFlag,
  mk: FlagFileNames.MacedonianFlag,
  ml: FlagFileNames.MalayaliFlag,
  mn: FlagFileNames.MongolianFlag,
  mr: FlagFileNames.IndianFlag,
  ms: FlagFileNames.MalayFlag,
  mt: FlagFileNames.MalteseFlag,
  my: FlagFileNames.MyanmarFlag,
  ne: FlagFileNames.NepaliFlag,
  nl: FlagFileNames.DutchFlag,
  no: FlagFileNames.NorwegianFlag,
  nso: FlagFileNames.SouthAfricanFlag,
  ny: FlagFileNames.MalawiFlag,
  oc: FlagFileNames.FrenchFlag,
  or: FlagFileNames.IndianFlag,
  pa: FlagFileNames.IndianFlag,
  pl: FlagFileNames.PolishFlag,
  ps: FlagFileNames.AfghanFlag,
  pt: FlagFileNames.BrazilianFlag,
  "pt-BR": FlagFileNames.BrazilianFlag,
  "pt-PT": FlagFileNames.PortugueseFlag,
  ro: FlagFileNames.RomanianFlag,
  ru: FlagFileNames.RussianFlag,
  sd: FlagFileNames.IndianFlag,
  sk: FlagFileNames.SlovakFlag,
  sl: FlagFileNames.SlovenianFlag,
  sn: FlagFileNames.SouthAfricanFlag,
  so: FlagFileNames.SomaliFlag,
  sr: FlagFileNames.SerbianFlag,
  sv: FlagFileNames.SwedishFlag,
  sw: FlagFileNames.KenyaFlag,
  ta: FlagFileNames.IndianFlag,
  te: FlagFileNames.IndianFlag,
  tg: FlagFileNames.TajikFlag,
  th: FlagFileNames.ThaiFlag,
  tl: FlagFileNames.FilipinoFlag,
  tr: FlagFileNames.TurkishFlag,
  uk: FlagFileNames.UkrainianFlag,
  ur: FlagFileNames.PakistaniFlag,
  umb: FlagFileNames.AngolaFlag,
  uz: FlagFileNames.UzbekFlag,
  vi: FlagFileNames.VietnameseFlag,
  wo: FlagFileNames.SenegalFlag,
  xh: FlagFileNames.SouthAfricanFlag,
  yue: FlagFileNames.HongKongFlag,
  zu: FlagFileNames.SouthAfricanFlag,
  zh: FlagFileNames.ChineseFlag,
};

export const accentsToFlagName: Record<string, FlagFileNames> = {
  "in-desi": FlagFileNames.IndianFlag,
  "es-castilian": FlagFileNames.SpanishFlag,
  "fr-swiss": FlagFileNames.FrenchFlag,
  "tr-istanbul": FlagFileNames.TurkishFlag,
  "cs-moravian": FlagFileNames.CzechFlag,
  "en-british": FlagFileNames.UKFlag,
  "en-canadian": FlagFileNames.CanadianFlag,
  "en-newyork": FlagFileNames.AmericanFlag,
  "en-australian": FlagFileNames.AustralianFlag,
  "en-indian": FlagFileNames.IndianFlag,
  "en-irish": FlagFileNames.IrishFlag,
  "it-italian": FlagFileNames.ItalianFlag,
  "en-essex": FlagFileNames.UKFlag,
  "sv-scandinavian": FlagFileNames.SwedishFlag,
  "de-german": FlagFileNames.GermanFlag,
  "de-bavarian": FlagFileNames.GermanFlag,
  "ru-russian": FlagFileNames.RussianFlag,
  "es-spanish": FlagFileNames.SpanishFlag,
  "es-latinamerican": FlagFileNames.MexicanFlag,
  "es-mexican": FlagFileNames.MexicanFlag,
  "es-argentine": FlagFileNames.ArgentineFlag,
  "pt-portuguese": FlagFileNames.PortugueseFlag,
  "en-californian": FlagFileNames.AmericanFlag,
  "en-african": FlagFileNames.AmericanFlag,
  "ur-pakistani": FlagFileNames.PakistaniFlag,
  "en-scottish": FlagFileNames.ScottishFlag,
  "en-southern": FlagFileNames.AmericanFlag,
  "en-texas": FlagFileNames.AmericanFlag,
  "en-country": FlagFileNames.AmericanFlag,
  "en-cockney-accent": FlagFileNames.UKFlag,
  "en-latino": FlagFileNames.AmericanFlag,
  "en-american": FlagFileNames.AmericanFlag,
  "en-filipino": FlagFileNames.FilipinoFlag,
};

// Mapping of locales to country short codes
export const languageToCountryCode: Record<string, string> = {
  af: "za", // South Africa
  am: "et", // Ethiopia
  ar: "ae", // UAE
  as: "in", // India
  ast: "es", // Spain
  az: "az", // Azerbaijan
  be: "by", // Belarus
  bg: "bg", // Bulgaria
  bn: "bd", // Bangladesh
  br: "br", // Brazil
  bs: "ba", // Bosnia
  ca: "es", // Spain
  ceb: "ph", // Philippines
  ckb: "iq", // Iraq (Kurdistan)
  cmn: "cn", // China
  cs: "cz", // Czech Republic
  cy: "gb", // UK (Wales)
  da: "dk", // Denmark
  de: "de", // Germany
  el: "gr", // Greece
  en: "us", // United States
  es: "es", // Spain
  et: "ee", // Estonia
  fa: "ir", // Iran
  ff: "sn", // Senegal
  fi: "fi", // Finland
  fr: "fr", // France
  ga: "ie", // Ireland
  gl: "es", // Spain (Galicia)
  gu: "in", // India
  ha: "ng", // Nigeria
  he: "il", // Israel
  hi: "in", // India
  hr: "hr", // Croatia
  hu: "hu", // Hungary
  hy: "am", // Armenia
  id: "id", // Indonesia
  ig: "ng", // Nigeria
  is: "is", // Iceland
  it: "it", // Italy
  ja: "jp", // Japan
  jv: "id", // Indonesia
  ka: "ge", // Georgia
  kea: "cv", // Cape Verde
  kk: "kz", // Kazakhstan
  km: "kh", // Cambodia
  kn: "in", // India
  ko: "kr", // South Korea
  ky: "kg", // Kyrgyzstan
  lb: "lu", // Luxembourg
  lg: "ug", // Uganda
  ln: "cd", // DR Congo
  lo: "la", // Laos
  luo: "ke", // Kenya
  lt: "lt", // Lithuania
  lv: "lv", // Latvia
  mi: "nz", // New Zealand (Maori)
  mk: "mk", // North Macedonia
  ml: "in", // India (Malayalam)
  mn: "mn", // Mongolia
  mr: "in", // India
  ms: "my", // Malaysia
  mt: "mt", // Malta
  my: "mm", // Myanmar
  ne: "np", // Nepal
  nl: "nl", // Netherlands
  no: "no", // Norway
  nso: "za", // South Africa
  ny: "mw", // Malawi
  oc: "fr", // France (Occitan)
  or: "in", // India
  pa: "in", // India
  pl: "pl", // Poland
  ps: "af", // Afghanistan
  pt: "br", // Brazil
  "pt-BR": "br", // Brazil
  "pt-PT": "pt", // Portugal
  ro: "ro", // Romania
  ru: "ru", // Russia
  sd: "in", // India
  sk: "sk", // Slovakia
  sl: "si", // Slovenia
  sn: "za", // South Africa
  so: "so", // Somalia
  sr: "rs", // Serbia
  sv: "se", // Sweden
  sw: "ke", // Kenya
  ta: "in", // India
  te: "in", // India
  tg: "tj", // Tajikistan
  th: "th", // Thailand
  tl: "ph", // Philippines
  tr: "tr", // Turkey
  uk: "ua", // Ukraine
  ur: "pk", // Pakistan
  umb: "ao", // Angola
  uz: "uz", // Uzbekistan
  vi: "vn", // Vietnam
  wo: "sn", // Senegal
  xh: "za", // South Africa
  yue: "hk", // Hong Kong
  zu: "za", // South Africa
  zh: "cn", // China
};

// Mapping of accents to country short codes
export const accentsToCountryCode: Record<string, string> = {
  "in-desi": "in", // India
  "es-castilian": "es", // Spain
  "fr-swiss": "ch", // Switzerland
  "tr-istanbul": "tr", // Turkey
  "cs-moravian": "cz", // Czech Republic
  "en-british": "gb", // UK
  "en-canadian": "ca", // Canada
  "en-newyork": "us", // United States
  "en-australian": "au", // Australia
  "en-indian": "in", // India
  "en-irish": "ie", // Ireland
  "it-italian": "it", // Italy
  "en-essex": "gb", // UK
  "sv-scandinavian": "se", // Sweden
  "de-german": "de", // Germany
  "de-bavarian": "de", // Germany
  "ru-russian": "ru", // Russia
  "es-spanish": "es", // Spain
  "es-latinamerican": "mx", // Mexico
  "es-mexican": "mx", // Mexico
  "es-argentine": "ar", // Argentina
  "pt-portuguese": "pt", // Portugal
  "en-californian": "us", // United States
  "en-african": "us", // United States
  "ur-pakistani": "pk", // Pakistan
  "en-scottish": "gb", // UK
  "en-southern": "us", // United States
  "en-texas": "us", // United States
  "en-country": "us", // United States
  "en-cockney-accent": "gb", // UK
  "en-latino": "us", // United States
  "en-american": "us", // United States
  "en-filipino": "ph", // Philippines
};

// Helper function to get flag name from locale
export function getFlagNameFromLocale(locale: string): FlagFileNames {
  return languageToFlagName[locale] || accentsToFlagName[locale] || FlagFileNames.AmericanFlag;
}

// Helper function to get country code from locale
export function getCountryCodeFromLocale(locale: string): string {
  return languageToCountryCode[locale] || accentsToCountryCode[locale] || "us";
}
